import { defineMessages } from "react-intl";
const messages = defineMessages({
    dateRangeError: {
        id: "app.scanCompleted.table.schedule.dateRangeError",
        defaultMessage: "End time must be after start time. Please, check.",
    },
    invalidTimeError: {
        id: "app.scanRequests.schedule.invalidTimeError",
        defaultMessage: "Invalid date on {value}. Please, rewrite.",
    },
});
export default messages;
